var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "regist" },
    [
      _vm._t("note"),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "passwordForm",
          attrs: { method: "post" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c("input", {
            attrs: { name: _vm.dataCsrfName, type: "hidden" },
            domProps: { value: _vm.dataCsrf },
          }),
          _vm._v(" "),
          _vm._t("errors"),
          _vm._v(" "),
          _c("dl", { staticClass: "formContainer" }, [
            _c("dt", [_vm._v("パスワード")]),
            _vm._v(" "),
            _c(
              "dd",
              [
                _vm.$v.password.$error
                  ? [
                      !_vm.$v.password.required
                        ? _c("span", { staticClass: "errNote" }, [
                            _vm._v("パスワードを入力してください。"),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "pswdShowHide" }, [
                  _vm.inputType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.password.$model,
                            expression: "$v.password.$model",
                          },
                        ],
                        staticClass: "regular",
                        attrs: {
                          name: "password",
                          placeholder: "パスワード",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.$v.password.$model)
                            ? _vm._i(_vm.$v.password.$model, null) > -1
                            : _vm.$v.password.$model,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.$v.password.$model,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.$v.password,
                                    "$model",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.$v.password,
                                    "$model",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.$v.password, "$model", $$c)
                            }
                          },
                        },
                      })
                    : _vm.inputType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.password.$model,
                            expression: "$v.password.$model",
                          },
                        ],
                        staticClass: "regular",
                        attrs: {
                          name: "password",
                          placeholder: "パスワード",
                          type: "radio",
                        },
                        domProps: {
                          checked: _vm._q(_vm.$v.password.$model, null),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.$v.password, "$model", null)
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.password.$model,
                            expression: "$v.password.$model",
                          },
                        ],
                        staticClass: "regular",
                        attrs: {
                          name: "password",
                          placeholder: "パスワード",
                          type: _vm.inputType,
                        },
                        domProps: { value: _vm.$v.password.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.password,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      class: _vm.iconClass,
                      attrs: {
                        tabIndex: "0",
                        "aria-label": "パスワード表示/非表示",
                      },
                      on: {
                        click: _vm.toggle,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.toggle.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("パスワード表示/非表示")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "formNote" },
                  [_vm._t("recovery-note")],
                  2
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btnSpace" }, [
            _c(
              "button",
              { attrs: { disabled: _vm.isDisabled, type: "submit" } },
              [_vm._v("ログイン")]
            ),
          ]),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }